import { NextPage } from 'next';
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import ErrorBoundary from '@/components/ErrorBoundary';
import HeadMeta from '@/components/static-pages/HeadMeta';
import SavedRentalsTemplate from '@/components/templates/SavedRentalsTemplate';
import { getSavedRentals } from '@/redux/modules/savedRentals';
import { getIsAuthenticated } from '@/redux/selectors/auth/user';

const SavedPage: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const isAuthenticated = useSelector(getIsAuthenticated);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getSavedRentals());
    }
  }, [dispatch, isAuthenticated]);

  return (
    <>
      <HeadMeta
        title={intl.formatMessage({
          defaultMessage: 'Favorites',
          id: 'SMrXWc',
        })}
        noindex
      />
      <SavedRentalsTemplate />
    </>
  );
};

const SavedPageWithinErrorBoundary: NextPage = () => {
  return (
    <ErrorBoundary>
      <SavedPage />
    </ErrorBoundary>
  );
};

export default SavedPageWithinErrorBoundary;
